import React from 'react';
import GradeLevelPie from "../building/gradeLevelPie";

function TeacherSummaryCard({data, startDate, endDate}) {

    const pieData = data.rosters.filter(roster => roster.data !== 'no data collected').flatMap(roster => roster.data).reduce((acc, obj) => {
        for (let key in obj) {
            acc[key] = (acc[key] || 0) + obj[key];
        }
        return acc;
    }, {});

    const dataInput = {
        totalAssessmentsEntries: (startDate !== "") ? data.rosters.flatMap(item => item.assessmentHistory).filter(item => new Date(item.date.$date) >= new Date(startDate) && new Date(item.date.$date) <= new Date(endDate)).length : data.rosters.flatMap(item => item.assessmentHistory).filter(item => new Date(item.date.$date) <= new Date(endDate)).length,
        correct: pieData.correctCount / pieData.total,
        incorrect: pieData.incorrectCount / pieData.total,
        pending: pieData.pendingCount / pieData.total
    }

    return (
        <div className={'rounded bg-columbia_blue-900 flex flex-col'}>

            <div className={'flex'}>

                <div className={'w-[40%] my-auto p-2'}>
                    <p className={'font-bold text-dutch_white-200 text-left text-2xl'}>{data.firstName} {data.lastName}</p>
                </div>

                <div className={'w-[60%]'}>
                    <GradeLevelPie data={dataInput} />
                </div>

            </div>

            <div className={'grid grid-cols-2 gap-2 p-1'}>
                {data.rosters.sort((a, b) => a.title.localeCompare(b.title)).map(roster => (
                    <div className={'bg-columbia_blue-800 text-dutch_white-100 flex flex-col p-1 rounded'}>
                        <div className={'flex justify-between text-left text-sm'}>
                            <p className={'max-w-[40%]'}>{roster.title}</p>
                            <p>{roster.students} students</p>
                        </div>
                        <div className={'flex justify-between text-left text-sm'}>
                            <p className={'max-w-[40%]'}>{roster.prep}</p>
                            {(startDate === "") ?
                                <p>{roster.assessmentHistory.filter(item => new Date(item.date.$date) <= new Date(endDate)).length} assessments</p>
                                :
                                <p>{roster.assessmentHistory.filter(item => new Date(item.date.$date) >= new Date(startDate) && new Date(item.date.$date) <= new Date(endDate)).length} assessments</p>
                            }
                        </div>
                        <div className={'grow'}/>
                        {(roster.data) ?
                            <div className={'flex gap-1'}>
                                {(roster.data.correctFreq) ?

                                    <div style={{width: `${roster.data.correctFreq * 100}%`}}
                                         className={`bg-columbia_blue-700 border-dutch_white-100 rounded border-[1px]`}>
                                        <svg
                                            width={20}
                                            height={30}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="black"
                                            strokeWidth="2"
                                            className={'mx-auto'}
                                        >{/* Added fill to rectangle */}
                                            <path d="M4 12 L8 16 L16 8" stroke="#f6f0e0" strokeWidth="1.5" fill="none"/>
                                            {/* Centered the checkmark */}
                                        </svg>
                                    </div> : <></>
                                }

                                {(roster.data.incorrectFreq) ?

                                    <div style={{width: `${roster.data.incorrectFreq * 100}%`}}
                                         className={`bg-burnt_sienna-600 rounded border-dutch_white-100 border-[1px]`}>
                                        <svg
                                            width={20}
                                            height={20}
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            stroke="black"
                                            strokeWidth="2"
                                            className={'mx-auto mt-[10px]'}
                                        >
                                            <path d="M5 2 L13 10 M13 2 L5 10" stroke="#f6f0e0" strokeWidth="1.5"
                                                  fill="none"/>
                                            {/* Centered the checkmark */}
                                        </svg>
                                    </div> : <></>
                                }

                                {(roster.data.pendingFreq) ?
                                    <div style={{width: `${roster.data.pendingFreq * 100}%`}}
                                         className={`bg-platinum-700 rounded border-dutch_white-100 border-[1px] overflow-hidden`}>
                                        <svg
                                            width={18}
                                            height={30}
                                            viewBox="0 0 8 8"  // Adjust the viewBox to be closer to the text size
                                            fill="none"
                                            stroke="#f6f0e0"
                                            strokeWidth="0.2"
                                            className={'mx-auto my-auto'}
                                        >
                                            <text
                                                x="50%"
                                                y="50%"
                                                textAnchor="middle"
                                                dominantBaseline="middle" // Centers text properly
                                                fill="#f6f0e0"
                                                fontSize="6"  // Adjust font size as needed
                                            >
                                                ?
                                            </text>
                                        </svg>
                                    </div> : <></>
                                }
                                {/*<p>Total Assessments: {roster.data.total}</p>*/}
                            </div>
                            :
                            <div className={'flex flex-col'}>
                                <p className={'opacity-50'}>No Data Collected</p>
                            </div>
                        }

                    </div>
                ))}
            </div>

        </div>
    );
}

export default TeacherSummaryCard;